'use client';
import styled from '@benzinga/themetron';
import React from 'react';

interface AmplyWidgetProps {
  attrs?: any;
  count?: number;
  id?: string;
  variant?: 'horizontal' | 'masonry' | 'sidebar';
}

export const AmplyWidget = (props: AmplyWidgetProps) => {
  const { id = `amply-widget-${Math.random().toString(36).substring(7)}`, variant = 'horizontal' } = props;
  const [initialized, setInitialized] = React.useState(false);

  const count = props?.attrs?.data?.count ?? props?.count ?? 1;

  React.useEffect(() => {
    let timeout: undefined | NodeJS.Timeout = undefined;

    const loadJobbioSidebarScript = () => {
      let script = document.getElementById('jobbio-display-script') as HTMLScriptElement | null;

      if (!script) {
        script = document.createElement('script') as HTMLScriptElement;
        script.src = 'https://widgets.jobbio.com/partner_fluid_widgets_v1.6.1/display.min.js';
        script.id = 'jobbio-display-script';
        script.defer = true;
        document.head.appendChild(script);
      }

      if (script && !initialized) {
        initializeJobbioSidebarScript();
      }
    };

    const initializeJobbioSidebarScript = () => {
      if (typeof (global as any).jobbio_display !== 'undefined') {
        const existing = document.getElementById(id);
        if (existing !== null && existing.children.length > 0) {
          clearTimeout(timeout);
          return;
        } else if (existing !== null && existing.children.length === 0 && !initialized) {
          (global as any).jobbio_display?.widget({
            container: id,
            content: 'jobs',
            count: count,
            // searchTerm: 'yyyy',
            slug: 'benzinga-jobs',
            style: variant,
            type: 'multiple',
          });
          setInitialized(true);
          clearTimeout(timeout);
          return;
        }
      } else {
        timeout = setTimeout(initializeJobbioSidebarScript, 1000);
      }
    };

    loadJobbioSidebarScript();
    return () => {
      clearTimeout(timeout);
    };
  }, [count, id, initialized, variant]);

  return <JobbioContainer className="jobbioapp" id={id}></JobbioContainer>;
};

export default AmplyWidget;

const JobbioContainer = styled.div`
  /* Anything after the first element should not be visible. */
  /* The id horizontal-job-multiple can only have 4 children max */
  #horizontal-job-multiple {
    /* After the 4th child set display to none */
    & > *:nth-child(n + 5) {
      display: none;
    }
  }

  & > *:not(:first-child) {
    display: none;
  }
`;
